<span class="select-component">
    <label>{{ label | translate }}</label>
    <div class="content">
        <mat-select class="form-select" [ngClass]="{ 'disabled': isDisabled || control.disabled, 'is-invalid': control.invalid && control.touched }" [formControl]="control" [placeholder]="placeholder | translate" panelClass="form-panel" [multiple]="isMultiselect" hideSingleSelectionIndicator="true">
            @if (optionsGroups != null) {
                @for (optionGroup of optionsGroups; track $index) {
                    <mat-optgroup label="--------------------------------------------">
                        @for (option of optionGroup; track option.value) {
                            <mat-option class='teste-mat' [value]="option.value">{{option.name | translate}}</mat-option>
                        }
                    </mat-optgroup>
                }
            } @else  {
                @for (option of options; track option.value) {
                    <mat-option [value]="option.value">{{option.name | translate}}</mat-option>
                }
            }
        </mat-select>
    </div>
</span>
